
import { createSlice,createAsyncThunk } from "@reduxjs/toolkit";
import ProfileService from "./profile_service";
import Translation from "../../utils/Translation";
import { setUser, logoutRequest } from "../auth/authSlice";
import { checkFindProfileUser } from "../../utils/helpers";

const initialState = {
    authUid: null,
    loadRequestId: null,
    refreshRequestId: null,
    isLoading:false,
    userProfile: null,
    errorProfile: null,
    statusProfile: 'idle',
    statusUpdateProfile: 'idle',
    statusVerifyEmail:'idle',
    verifyEmail:false,
    isDriver:false,
    nickName:null,
    email:null,
    profile_url:'',
    userType:0,
    findErrorProfile:false,
    statusProfileUpdateFirstTime:"idle"
};

// Async action creator
export const  loadProfileAsync = createAsyncThunk("type/loadProfileAsync", async ({auth,dynamicState},{rejectWithValue}) => {

  try{

  const profile = await ProfileService.loadProfile({auth,dynamicState}); // Assuming loadProfile is an async function
   
  return profile;

  }catch (error){

    return rejectWithValue({error:error.getError().message})
  }
}, {
  condition: (_, { getState }) => getState().profile.statusProfile !== "loading",
});


export const  refreshProfileAsync = createAsyncThunk("type/refreshProfileAsync", async ({auth,dynamicState},{rejectWithValue}) => {

  try{

  const profile = await ProfileService.loadProfile({auth,dynamicState}); // Assuming loadProfile is an async function
  // Keep the no-profile sentinel intact; spreading 0 creates a fake profile.
  return auth?.user?.isAnonymous ? null : profile;


  }catch (error){

    return rejectWithValue({error:error.getError().message})
  }
});


export const  updateProfileAsync = createAsyncThunk("type/updateProfileAsync", async ({auth,dynamicState,nickName,email,profile_url,userFormType,mobileNumber,password},{dispatch,rejectWithValue}) => {

  try{
    await ProfileService.updateProfile({auth,dynamicState,nickName,email,profile_url,userFormType,mobileNumber,password}); // Assuming updateProfile is an async function

    // Read the saved account back before enabling account-restricted APIs.
    return await ProfileService.loadProfile({ auth, dynamicState });
  }catch(error){
  
    return rejectWithValue({error:error.getError().message})
  }
   
});


export const sendVerifyEmailAsync =  createAsyncThunk("type/sendVerifyEmailAsync", async ({auth,dynamicState},{rejectWithValue}) => {
      
  try{ 
    const sendVerifyEmail = await ProfileService.sendVerifyEmail({auth,dynamicState}); // Assuming updateProfile is an async function
   
    return sendVerifyEmail;
  }catch(error){
    return rejectWithValue({error:error.getError().message})
  }
   
});

const profileSlice = createSlice({
    name: 'profile',
    initialState,
    reducers: {
        setLoading: (state, action) => {
        state.isLoading = action.payload.isLoading;
        },
        setStatusProfileUpdateFirstTime: (state, action) => {
          state.statusProfileUpdateFirstTime = action.payload;
        },
        setStatusProfile: (state, action) => {
          state.statusProfile = action.payload.statusProfile;
        },
        setUserProfile: (state,action) => {
           state.userProfile = action.payload.userProfile;
        },
        updateUserProfile:(state,action) => {
          state.nickName = action.payload.nickName;
          state.email = action.payload.email;
          state.profile_url = action.payload.profile_url;
          state.userType = action.payload.userFormType;
        },setStatusVerifyEmail:(state,action) => {
          state.statusVerifyEmail = action.payload;
        },setVerifyEmail : (state,action) => {
          state.verifyEmail = action.payload;
        },setProfile_url : (state,action) => {
          state.profile_url = action.payload
        },setFindErrorProfile : (state,action) => {
          state.findErrorProfile = action.payload
        },setErrorProfile : (state,action) => {
          state.errorProfile = action.payload
        }, resetProfile: (state) => ({ ...initialState, authUid: state.authUid })
    },
    extraReducers: builder => {
        builder
          .addCase(setUser, (state, action) => {
            const uid = action.payload.user?.isAnonymous ? null : action.payload.user?.uid ?? null;
            if (uid !== state.authUid) return { ...initialState, authUid: uid };
          })
          .addCase(logoutRequest.fulfilled, () => ({ ...initialState }))
          .addCase(loadProfileAsync.pending, (state, action) => {
            state.loadRequestId = action.meta.requestId;
            state.isLoading = true;
            state.statusProfile = 'loading';
            state.errorProfile = null;
            state.findErrorProfile = false;
          })
          .addCase(loadProfileAsync.fulfilled, (state, action) => {
            if (state.loadRequestId !== action.meta.requestId) return;
            state.userProfile =  action.payload;
            state.verifyEmail = Boolean(action.payload?.email_verified);
            state.isLoading = false;
            state.statusProfile = 'succeeded';
            state.errorProfile = null;
            // set phone number in local storage
            if (action.payload?.mobile_number) localStorage.setItem("phoneNumber", action.payload.mobile_number);
          })
          .addCase(loadProfileAsync.rejected, (state, action) => {
            if (state.loadRequestId !== action.meta.requestId) return;
            state.isLoading = false;
            state.statusProfile = 'failed';
            state.errorProfile = action.payload?.error;
            state.findErrorProfile = true;
            console.log("Error in Get Profile : "+ action.payload?.error);
          })
          .addCase(refreshProfileAsync.pending, (state, action) => {
            state.refreshRequestId = action.meta.requestId;
            state.errorProfile = null;
            state.findErrorProfile = false;
          })
          .addCase(refreshProfileAsync.fulfilled, (state, action) => {
            if (state.refreshRequestId !== action.meta.requestId || (action.meta.arg.auth?.user?.uid ?? null) !== state.authUid) return;
            state.userProfile = action.payload;
            state.verifyEmail = Boolean(action.payload?.email_verified);
            state.errorProfile = null;
          })
          .addCase(refreshProfileAsync.rejected, (state, action) => {
            if (state.refreshRequestId !== action.meta.requestId || (action.meta.arg.auth?.user?.uid ?? null) !== state.authUid) return;
            state.errorProfile = action.payload?.error;
            state.findErrorProfile = true;
            console.log("Error in Get Profile : "+ action.payload?.error);
          })
          .addCase(updateProfileAsync.pending, (state, action) => {
            state.refreshRequestId = null;
            // state.isLoading = true;
            if(!checkFindProfileUser(state.userProfile)) state.statusProfileUpdateFirstTime = "loading"
            else  state.statusUpdateProfile = 'loading';
            state.errorProfile = null;
          })
          .addCase(updateProfileAsync.fulfilled, (state, action) => {
            if ((action.meta.arg.auth?.user?.uid ?? null) !== state.authUid) return;
            state.refreshRequestId = null;
            // state.isLoading = false;
            if(state.statusProfileUpdateFirstTime === "loading") state.statusProfileUpdateFirstTime = "succeeded"
            else  state.statusUpdateProfile = 'succeeded';
            state.userProfile = action.payload;
            state.verifyEmail = Boolean(action.payload?.email_verified);
            state.errorProfile = null;
          })
          .addCase(updateProfileAsync.rejected, (state, action) => {
            if ((action.meta.arg.auth?.user?.uid ?? null) !== state.authUid) return;
            // state.isLoading = false;
            if(state.statusProfileUpdateFirstTime === "loading") state.statusProfileUpdateFirstTime = "failed"
            else  state.statusUpdateProfile = 'failed';
            state.errorProfile = action.payload?.error;
            console.log("Error in Update Profile : "+ action.payload?.error);
          })
          
          .addCase(sendVerifyEmailAsync.pending, (state, action) => {
            state.statusVerifyEmail = 'loading';
            state.errorProfile = null;
          })
          .addCase(sendVerifyEmailAsync.fulfilled, (state, action) => {
            state.statusVerifyEmail = 'succeeded';
            state.errorProfile = null;
          })
          .addCase(sendVerifyEmailAsync.rejected, (state, action) => {
            state.statusVerifyEmail = 'failed';
            state.errorProfile = action.payload?.error === undefined ?  <Translation data={"profile.cannot_send_request"}  />  :action.payload?.error;
            console.log("Error in Verify Email Profile : "+ action.payload?.error);
          })
      }
});


export const {setStatusProfileUpdateFirstTime,setStatusProfile,setUserProfile,updateUserProfile,
  setStatusVerifyEmail,setVerifyEmail,setLoading,setProfile_url,setFindErrorProfile,setErrorProfile,resetProfile} = profileSlice.actions;
export default profileSlice.reducer;